import React from 'react';
import { Button } from 'antd';
import { helpers } from 'helpers';
import { useTypedSelector } from 'Store/_Store';

interface Props {
    meta: {
        next: string;
        page: number;
        total: number;
        limit: number;
        previous: string;
    };
    navigate: (cursor: string) => void;
}
const Pagination = ({ meta, navigate }: Props) => {
    const { _utils: { limit } } = useTypedSelector((state) => state);

    const divid = (meta.total / (meta.limit || limit)).toString().split('.');
    const totalPages = (+(+divid[0] + +(divid[1] ? 1 : 0))) || 1;

    return (
        <React.Fragment>
            <div id="Pagination">
                <div className="flex justify-between items-center">
                    <div>
                        <Button
                            type="default"
                            disabled={!meta.previous}
                            onClick={() => navigate(meta.previous)}
                        >
                            Previous
                        </Button>
                        &nbsp; &nbsp;
                        <Button
                            type="default"
                            disabled={!meta.next}
                            onClick={() => navigate(meta.next)}
                        >
                            Next
                        </Button>
                    </div>
                    {totalPages && (
                        <div className="text-gray-500 text-sm">
                            Page {meta.page} of {helpers.format.number(totalPages, 0)}
                        </div>
                    )}
                </div>
            </div>
        </React.Fragment>
    );
}


export default Pagination;